export const LOGOUT = 'LOGOUT'

export const LOGIN = {
  START: 'START_LOGIN',
  COMPLETE: 'COMPLETE_LOGIN',
  FAIL: 'FAIL_LOGIN',
}

export const REFRESH_TOKEN = {
  START: 'START_REFRESH_TOKEN',
  COMPLETE: 'COMPLETE_REFRESH_TOKEN',
  FAIL: 'FAIL_REFRESH_TOKEN',
}

export const UPDATE_USER_SETTINGS = {
  START: 'START_UPDATE_USER_SETTINGS',
  COMPLETE: 'COMPLETE_UPDATE_USER_SETTINGS',
  FAIL: 'FAIL_UPDATE_USER_SETTINGS',
}

export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN'
